import React, {useState, useEffect, useRef, useCallback, Suspense} from 'react'
import PicCont from './PicCont'
import TopMenu from './TopMenu'
import { helper } from '../utilities/helper';
import Button from './Button';
import Clickable from './Clickable';
import { getUser, cartAddItem } from '../store/slices/user';
import { useSelector, useDispatch } from 'react-redux';
import { getWorkingPackage } from '../store/slices/entities/packages';
import { getWorkingOrder, workingOrderReset } from '../store/slices/entities/orders';
import { getAllFilteredProducts, getProductsFilters, productsResetFilters } from '../store/slices/entities/products';
import { loadEntityForce } from '../store/slices/entities/crmActions';
import { apiCallBegan } from '../store/api';
import { AiOutlineShoppingCart } from "@react-icons/all-files/ai/AiOutlineShoppingCart";
import { AiOutlineCar } from "@react-icons/all-files/ai/AiOutlineCar";
import { FaWrench } from '@react-icons/all-files/fa/FaWrench';
import { useRouter } from 'next/router';
import LinkWrap from './LinkWrap';
import {TooltipIcon, Spinner} from './Components';
import { useInView } from 'react-intersection-observer';
import { AiOutlineDoubleRight } from '@react-icons/all-files/ai/AiOutlineDoubleRight';
import { FiChevronsDown } from '@react-icons/all-files/fi/FiChevronsDown';
import { FaWarehouse } from "@react-icons/all-files/fa/FaWarehouse";
import dynamic from 'next/dynamic'
import { useOrderFlow } from './unified-order/OrderFlowProvider';
const AddUnits = dynamic(() => import('./AddUnits'), { suspense: true })

const SubCatCont = ({products, subCat}) => {
    products = products.sort((a,b) => b?.tags?.includes('Top Seller') - a?.tags?.includes('Top Seller'))
    let [tab, setTab] = useState(products[0]?.name)
    let [product, setProduct] = useState(products[0])
    let { cart } = useSelector(getUser)
    let dispatch = useDispatch()
    let order = useSelector(getWorkingOrder)
    let workingPackage = useSelector(getWorkingPackage)
    let _products = useSelector(getAllFilteredProducts)
    let filters = useSelector(getProductsFilters)
    let { launchIntent, unifiedEnabled } = useOrderFlow()
    let unifiedEligible = unifiedEnabled && !workingPackage && !order?._id && !cart.items?.length
    let {query} = useRouter()
    let {item} = query
    let ref = useRef()
    let ref2 = useRef()
    const { ref: inViewRef, inView, entry } = useInView();

    useEffect(() => {
        if (item && products.find(p => p._id === item)) {
            setProduct(products.find(p => p._id === item))
            setTab(products.find(p => p._id === item).name)
            ref.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
        } 
    }, [item])

    useEffect(() => {
        setProduct(products.find(p => p.name === tab))
    }, [tab])
    const setRefs = useCallback(
      (node) => {
        ref2.current = node;
        inViewRef(node);
      },
      [inViewRef],
    );
    let addToPack = (units) => {
        let _pr = products.find(pr => pr.name === product.name)
        if (units > 0 && (_pr.available - units < 0 || (_pr.bundle && _pr.included.some(ip => products.find(produ => String(produ._id) == String(ip.product._id)).available - (units * ip.units) < 0)))) return dispatch(showAlert({ type: 'error', alert: `${product.name} has no more units available for the selected date` }))
        else {
            dispatch(geoProductsUpdateAvailability({ product, units }))
            dispatch(packageComponentAdded({ product, units, category: product.categories[0].split('/')[1] }))
        }
    }

    let addToCartItems = async (product, delivery) => {
        let units = 1
        if (unifiedEligible && !product.only_purchase && !product.price?.map) {
            return launchIntent({
                kind: 'product',
                entityId: product._id,
                entityName: product.name,
                sourceSurface: `subcategory:${subCat || 'unknown'}`,
                fulfillment: delivery ? 'delivery_setup' : 'pickup'
            })
        }
        if(filters.static) {
            await   dispatch(loadEntityForce('products'))
            dispatch(productsResetFilters())
        }
        let _pr = _products.find(pr => pr.name === product.name)
       
        if(delivery) {
            if(!cart.production  && order._id)  await   dispatch(apiCallBegan({url: `/order/${order._id}`, method: 'DELETE', onSuccess: workingOrderReset.type}))   
            return dispatch(cartAddItem({ product, units, category: product.categories[0].split('/')[1], delivery: true }))
       
        }  else {
            if (order?._id && units > 0 && (_pr.available - units < 0 || (_pr.bundle && _pr.included.some(ip => _products.find(produ => String(produ._id) == String(ip.product._id)).available - (units * ip.units) < 0)))) return dispatch(showAlert({ type: 'error', alert: `${product.name} has no more units available for the selected date` }))
            if (!cart.production && (product.requires_tech || !product.allow_pickup)) {
                if (!window.confirm(`${product.name} requires installation by a Dry N Wet technician, adding it to your order will convert it to a production. Do you wish to continue?`)) return
                else if(order._id) {
        
                 await   dispatch(apiCallBegan({url: `/order/${order._id}`, method: 'DELETE', onSuccess: workingOrderReset.type}))   
                }   
            }
           
          
          await  dispatch(cartAddItem({ product, units, category: product.categories[0].split('/')[1] }))
        }
    

    }



  return <div className='container'  ref={ref} >
  
      <ul className="productRow">
        {products.map((p,i) =><li ref={i=== products.length -1 ? setRefs : null} name={p._id}className={`link productMini ${tab === p.name ?'' : 'faded'}`} onClick={() => setTab(p.name)} key={i} > 
        <PicCont width={100} height={100} className='miniPic' picture={p?.picture} alt={p?.name} />
        <strong>{helper.shortText(p?.name, 8)}</strong>
        <strong className='colorText yellow'>{helper.formatPrice(p?.price?.rental)}</strong>
      </li>)}
      {!inView && <Clickable className='arrow' onClick={()=> ref2.current.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
           alignToTop: false
        })}>
  <AiOutlineDoubleRight className='onlyTablet' />
  <FiChevronsDown className='noTablet' />
  
    </Clickable>}
      </ul>
      <div className="productCont" name={product?._id}>
      <LinkWrap href={`/products/${helper.makeUrl(product?.name)}`} >
          <PicCont width={400} height={400} picture={product?.picture} alt={product?.name} />
          </LinkWrap>
       <div  className={`rightCol show`}>
              <h3>{product?.name}</h3>
              <p>{product?.description}</p>
              <LinkWrap href={`/products/${helper.makeUrl(product?.name)}`} >View Product Details</LinkWrap>
              <strong className="price">Rental Price: {helper.formatPrice(product?.price?.rental)} / 24h</strong>
              <strong className="delivery"> <TooltipIcon>We offer full delivery, installation, breakdown and technical assistance 24 hours 7 days per week including holidays. We service all south florida from Orlando to Key West. Our technicians will deliver the equipment at a time of your choice, install it according to your specifications and instruct you on how to use the equipment. Delivery and installation prices are calculated based on your location and delivery times, please click Schedule Deliver to get an exact price.</TooltipIcon> Estimated Delivery and Installation: {helper.formatPrice(product?.price.rental * ((product?.difficulty / 10) + 0.25))}</strong>
     
              {workingPackage ?  
             <Suspense fallback={<Spinner size='tiny' />}> <AddUnits subCat pack selectedUnits={workingPackage.components.find(item => item.product.name === product?.name)?.units || 0} product={product} /></Suspense>
            :
            <div className='buttons'>
            <Button onClick={() => addToCartItems(product, true)}   className={`btn-4 highLight`}><FaWrench />{unifiedEligible ? 'Add with delivery & setup' : 'We Install It'}</Button>
        {product?.allow_pickup &&   (cart?.items?.some(i => i?.product?._id === product._id) ? <Suspense fallback={<Spinner size='tiny' />}>  <AddUnits selectedUnits={cart?.items?.find(item => item.product.name === product?.name)?.units || 0} product={product} /></Suspense>
         : <Button onClick={() => addToCartItems(product)}   className='btn-4 highLight'><FaWarehouse /> {unifiedEligible ? 'Add for warehouse pickup' : 'You Pick It Up'}</Button>)}
            </div>
            }
        
          </div>
      </div>

  </div>
}

export default SubCatCont
